import React, { useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { LinkButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { InfoLabel } from '@eika/label';
import { Modal } from '@eika/modal';
import { ButtonToggles } from '@eika/radio-button';

import { UpdateConsent } from '../../actions';
import { StringKeyValue } from '../../actions/types';
import { ConsentData } from '../../reducers/consent';

interface Props {
    updateConsent: (name: UpdateConsent['name'], value: UpdateConsent['value']) => void;
    text: StringKeyValue;
    data: ConsentData;
}

const Consent = ({ data, updateConsent, text }: Props): JSX.Element => {
    const id: string = useRef(uuid()).current;
    const [showModal, setShowModal] = useState(false);

    const { infoTekst, svarNeiTekst, samtykkeId, svar, tittel, tekster, popupTekst } = data;

    const consentOptions = [
        { label: 'Ja', value: 'JA' },
        { label: 'Nei', value: 'NEI' },
    ];

    return (
        <div className="consent-item" id={id}>
            <ButtonToggles
                className="consent-item__options"
                label={infoTekst}
                options={consentOptions}
                selectedOption={svar}
                onChange={(value) => updateConsent(samtykkeId.value, value)}
            />

            {(tekster || popupTekst) && (
                <>
                    <LinkButton
                        className="consent-item__open-modal"
                        icon={IconTypes.INFO_24}
                        onClick={() => setShowModal(!showModal)}
                    >
                        {text.consentModalButtonOpenText}
                    </LinkButton>

                    <Modal
                        id={`modal_${id}`}
                        title={tittel}
                        onClose={() => setShowModal(false)}
                        show={showModal}
                        appNamespace="no-eika-lokalbank"
                    >
                        {tekster.filter(Boolean).map((tekst) => (
                            <p key={uuid()}>{tekst}</p>
                        ))}

                        {popupTekst && <p>{popupTekst}</p>}

                        <div className="consent-item__close-modal">
                            <StandardButton onClick={() => setShowModal(false)}>
                                {text.consentModalButtonCloseText}
                            </StandardButton>
                        </div>
                    </Modal>
                </>
            )}
            {svar === 'NEI' && svarNeiTekst && <InfoLabel className="consent-item__info" text={svarNeiTekst} />}
        </div>
    );
};

export default Consent;
